import { Localizable } from '@components/localizable/Localizable'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { Alert, Flex } from 'antd'
import { FC } from 'react'

interface Props {}

const BookingConnectorMembershipChatSection: FC<Props> = ({}) => {
  const venue = useAppSelector(selectSelectedVenue())

  if (!venue) return <></>

  return (
    <Flex vertical style={{ padding: 20 }} gap={16}>
      <Localizable.TextArea
        name={'bookingConnectorMembershipChatMessage'}
        label={'Pre-filled message'}
        max={250}
      />
      <Alert title="When the user clicks the “Book” button, it will open the membership chat (WhatsApp or Intercom depending on your setup). You can customize the pre-filled message, and the user can still edit it before sending. For non-members, the “Book” button will not be displayed." />
    </Flex>
  )
}

export { BookingConnectorMembershipChatSection }
